import React,{Component} from 'react'
import Api from "../../../ServiceApi";
const EmployeeStatus = ({statusData}) => {
  return(
    <React.Fragment>
    <div className="col-2" style={{display:"flex"}}>
    <ul>
      <li>
        <span>
          {" "}
          <img
            src={Api.absoluteUrl("/icon/check_list.svg")}
            alt=""
            className="mr-2"
          />
          Completed{" "}
        </span>
      </li>
      <li>
        <span>
          {" "}
          <img
            src={Api.absoluteUrl("/icon/corrective.svg")}
            alt=""
            className="mr-2"
          />
          Reject
        </span>
      </li>
      <li>
        <span>
          {" "}
          <img
            src={Api.absoluteUrl("/icon/clock.svg")}
            alt=""
            className="mr-2"
          />
          Transfer
        </span>
      </li>
      <li>
        <span>
          {" "}
          <img
            src={Api.absoluteUrl("/icon/status_report.svg")}
            alt=""
            className="mr-2"
          />
          Stop Time
        </span>
      </li>
    </ul>
  </div>
  <div className="col-2">
    <ul>
      <li style={{ color: "#000f9f" }}>
        <span>-
        {/* statusData.map field ได้เลย */}
        </span>
      </li>
      <li>
        <span>-
        {/* statusData.map field ได้เลย */}
        </span>
      </li>
      <li>
        <span>-
        {/* statusData.map field ได้เลย */}
        </span>
      </li>
      <li>
        <span>-
        {/* statusData.map field ได้เลย */}
        </span>
      </li>
    </ul>
  </div>
    </React.Fragment>
  );
}

export default EmployeeStatus;